const textFieldModelDocCompany = {
  company: 'Company'
};

export default textFieldModelDocCompany;
